import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'


const routes = [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/main-view.vue')
    },
    {
      path: '/post/:postId',
      name: 'PostDetail',
      component: () => import('@/views/post-view.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/append',
      name: 'Append',
      component: () => import('@/views/append-view.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/edit/:postId',
      name: 'Edit',
      component: () => import('@/views/edit-view.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login-view.vue')
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('@/views/logout-view.vue')
    }
  ]

const router = createRouter({
    history: createWebHistory(),
    routes
  })

router.beforeEach((to) => {
  const auth = useAuthStore()
  if (to.meta.requiresAuth && !auth.isLoggedIn) {
    return { name: 'Login', query: { redirect: to.fullPath } }
  }
})

export default router